/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable unicorn/no-array-reduce */
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect, useState } from 'react'
import { getTerms } from '../../services/useGetTerms'

export const useGetCustomerTypesDiscounts = () => {
  const {
    app: { marketExceptions },
    user: { customerType },
    cart: { otp, subscribe },
  } = useGlobalStore()

  const isTaxInclusive = marketExceptions?.tax?.inclusive || false
  const [discount, setDiscount] = useState(0)

  useEffect(() => {
    if (!customerType) return
    if (customerType === 'Customer') {
      setDiscount(0)
      return
    }

    const mergedCart = [...otp, ...subscribe]

    const itemsTotalCustomerPricing = mergedCart.reduce((accumulator, item) => {
      const terms = getTerms({
        forCustomerType: 'Customer',
        pricingData: item.product.pricing,
      })

      let itemTotal = 0
      if (terms?.priceEach) {
        itemTotal = terms.priceEach

        if (isTaxInclusive && terms.taxEach?.amount) {
          itemTotal += terms.taxEach.amount
        }

        itemTotal *= item.qty
      }

      return accumulator + itemTotal
    }, 0)

    const itemsTotalUserCustomerType = mergedCart.reduce(
      (accumulator, item) => {
        const terms = getTerms({
          forCustomerType: customerType,
          pricingData: item.product.pricing,
        })

        let itemTotal = 0
        if (terms?.priceEach) {
          itemTotal = terms.priceEach

          if (isTaxInclusive && terms.taxEach?.amount) {
            itemTotal += terms.taxEach.amount
          }

          itemTotal *= item.qty
        }

        return accumulator + itemTotal
      },
      0,
    )

    const totalDiscount = itemsTotalCustomerPricing - itemsTotalUserCustomerType
    setDiscount(totalDiscount)
  }, [
    customerType,
    otp,
    subscribe,
    isTaxInclusive,
    ...otp.map((item) => item.qty).join(','),
    ...subscribe.map((item) => item.qty).join(','),
  ])

  return { customerTypeDiscount: discount }
}
